<template>
  <div ref="turnstileContainer" aria-label="Security verification" />
</template>

<script setup>
const turnstileToken = defineModel({
  type: String,
  default: '',
})

const props = defineProps({
  action: {
    type: String,
    required: true,
  },
  appearance: {
    type: String,
    default: 'always',
    validator: (value) => ['always', 'execute', 'interaction-only'].includes(value),
  },
})

const emit = defineEmits(['error'])
const turnstileContainer = ref(null)
const productionTurnstileSiteKey = '0x4AAAAAAEkyOnf9mOlthr9d'
const turnstileAlwaysPassTestSiteKey = '1x00000000000000000000AA'
const turnstileSiteKey = import.meta.dev
  ? turnstileAlwaysPassTestSiteKey
  : productionTurnstileSiteKey

let turnstileWidgetId = null

const reset = () => {
  turnstileToken.value = ''

  if (window.turnstile && turnstileWidgetId !== null) {
    window.turnstile.reset(turnstileWidgetId)
  }
}

const renderTurnstile = () => {
  if (!turnstileContainer.value || !window.turnstile || turnstileWidgetId !== null) {
    return
  }

  turnstileWidgetId = window.turnstile.render(turnstileContainer.value, {
    sitekey: turnstileSiteKey,
    action: props.action,
    appearance: props.appearance,
    size: 'flexible',
    callback: (token) => {
      turnstileToken.value = token
    },
    'expired-callback': () => {
      turnstileToken.value = ''
    },
    'error-callback': (errorCode) => {
      turnstileToken.value = ''
      emit('error', errorCode)
    },
  })
}

onMounted(() => {
  window.addEventListener('turnstile-loaded', renderTurnstile)
  renderTurnstile()
})

onBeforeUnmount(() => {
  window.removeEventListener('turnstile-loaded', renderTurnstile)

  if (window.turnstile && turnstileWidgetId !== null) {
    window.turnstile.remove(turnstileWidgetId)
  }
})

defineExpose({ reset })
</script>
